const UNITS = ['B', 'K', 'M', 'G', 'T'];

export function bytes(n, digits = 1) {
  if (n == null) return '—';
  let i = 0;
  while (n >= 1024 && i < UNITS.length - 1) { n /= 1024; i++; }
  return `${n.toFixed(i === 0 ? 0 : digits)}${UNITS[i]}`;
}

export function money(n, digits = 0) {
  if (n == null) return '—';
  const sign = n < 0 ? '-' : '';
  return `${sign}$${Math.abs(n).toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits })}`;
}

// "+$1,234" / "-$56" — for P/L columns
export function signed(n, digits = 0) {
  if (n == null) return '—';
  return (n > 0 ? '+' : '') + money(n, digits);
}

export function pct(n, digits = 0) {
  return n == null ? '—' : `${n.toFixed(digits)}%`;
}

export function signedPct(n, digits = 1) {
  return n == null ? '—' : `${n > 0 ? '+' : ''}${n.toFixed(digits)}%`;
}

// 2026-10-16 → 10/16
export function mmdd(iso) {
  return iso ? `${iso.slice(5, 7)}/${iso.slice(8, 10)}` : '—';
}

export function clock(iso) {
  if (!iso) return '—';
  const d = new Date(iso);
  const today = new Date().toDateString() === d.toDateString();
  return today
    ? d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
    : d.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export const tone = n => (n > 0 ? 'up' : n < 0 ? 'down' : '');
